import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SignatureDishes() {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(0);

  useEffect(() => {
    axios
      .get(`${API}/menu`, { params: { featured: true } })
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, []);

  const pageSize = 3;
  const pages = Math.max(1, Math.ceil(items.length / pageSize));
  const slice = items.slice(page * pageSize, page * pageSize + pageSize);

  return (
    <section
      className="sd-signature py-20"
      style={{ backgroundImage: "url('/images/firebackdrop.jpg')" }}
      data-testid="signature-section"
    >
      <div className="max-w-7xl mx-auto px-6">
        <h2 data-testid="signature-heading">Our Signature Dishes</h2>
        <div className="sd-divider" />

        <div className="relative">
          {pages > 1 && (
            <button
              className="sd-arrow prev"
              onClick={() => setPage((p) => (p - 1 + pages) % pages)}
              data-testid="signature-prev"
              aria-label="Previous"
            >
              <ChevronLeft size={26} />
            </button>
          )}

          <div className="grid md:grid-cols-3 gap-8" data-testid="signature-grid">
            {slice.map((item) => (
              <Link
                to={`/highlights/${item.slug}`}
                key={item.slug}
                className="sd-dish-card block"
                data-testid={`dish-card-${item.slug}`}
              >
                <div className="overflow-hidden rounded">
                  <img src={item.image} alt={item.name} />
                </div>
                <h3>{item.name}</h3>
                <p>{item.description.slice(0, 110)}...</p>
              </Link>
            ))}
          </div>

          {pages > 1 && (
            <button
              className="sd-arrow next"
              onClick={() => setPage((p) => (p + 1) % pages)}
              data-testid="signature-next"
              aria-label="Next"
            >
              <ChevronRight size={26} />
            </button>
          )}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/order?location=rochester"
            className="sd-btn-red"
            data-testid="order-rochester-cta-1"
          >
            Order at Route 31 - Rochester Rd. Shop
          </Link>
        </div>
      </div>
    </section>
  );
}
